import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=c1b26332&scoped=true&"
import script from "./Secondary.vue?vue&type=script&lang=js&"
export * from "./Secondary.vue?vue&type=script&lang=js&"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=c1b26332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b26332",
  null
  
)

export default component.exports